import { useLingui } from '@lingui/react'
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { useController } from 'react-hook-form'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

/*eslint-disable*/
function DateTimeInput({ control, name, autoFocus = null, label }) {
    const { _ } = useLingui()
    const {
      field,
      fieldState: { invalid, isTouched, isDirty },
      formState: { touchedFields, dirtyFields },
    } = useController({
      name,
      control,
      rules: { required: true },
    })
  
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDateTimePicker
          label={label}
          disableFuture
          sx={{ width: '100%', marginTop: 1 }}
          mt={100}
          readOnly={false}
          value={field.value ? dayjs(field.value) : null}
          onAccept={date => {
            console.log('date ... ', date.format('YYYY-MM-DD hh:mm:ss'))
            field.onChange(date)
          }}
        />
      </LocalizationProvider>
    )
  }
  
  export default DateTimeInput;